import { render, staticRenderFns } from "./SegmentsChart.vue?vue&type=template&id=ed08e91c&scoped=true&"
import script from "./SegmentsChart.vue?vue&type=script&lang=js&"
export * from "./SegmentsChart.vue?vue&type=script&lang=js&"
import style0 from "./SegmentsChart.vue?vue&type=style&index=0&id=ed08e91c&scoped=true&lang=css&"
import style1 from "./SegmentsChart.vue?vue&type=style&index=1&id=ed08e91c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed08e91c",
  null
  
)

export default component.exports